// File used to plan regex segments

//Allowed patterns
// const valid1 = '={2112: Some Endpoint} * {Some Endpoint}'
// const valid2 = '={2112: Some Endpoint} +  10'
// const valid3 = '=(MAX( { 2112 : Weight}  )-  {Weight}  )>(MAX(  {2112: Weight}  )*.10) +10'

//Invalid patterns
// const invalid1 = '{2112: Some Endpoint} * {121: AS}'
// const invalid2 = '=10 + 2'
// const invalid3 = '={Some Endpoint}'

// Building Blocks
const operator = /(?:>=|<=|[+*/><\-=^,])/
const variable = /(?:{[^{:]+})/ // {Some Endpoint}
const variableRange = /(?:{[^{:]+:[^{:]+})/ // {Some Phase: Some Endpoint}
const number = /[0-9.]+/ // 101.1
const rangeFunc = /(?:MAX|MIN|AVERAGE|OR|AND)/
const openBracket = /[(\s]*/
const closeBracket = /[)\s]*/

const subOperator = operator.toString().slice(1, -1)
const subVariable = variable.toString().slice(1, -1)
const subVariableRange = variableRange.toString().slice(1, -1)
const subNumber = number.toString().slice(1, -1)
const subRangeFunc = rangeFunc.toString().slice(1, -1)
const subOpenBracket = openBracket.toString().slice(1, -1)
const subCloseBracket = closeBracket.toString().slice(1, -1)

export const rangeCalc = `(?:${subRangeFunc}\\s*\\(\\s*${subVariableRange}\\s*\\))`
export const anyValue = `(?:${rangeCalc}|${subVariable}|${subNumber}|[^\\s=]+)`
export const anyWrappedVal = `(?:${subOpenBracket}${anyValue}${subCloseBracket})`
export const opPlusVal = `(?:${subOperator}\\s*${anyWrappedVal})`

export const functionVal = `(?:${subRangeFunc}?\\s*[(]*)`
export const functionValEnding = `(?:[)]*)`
export const validForm = new RegExp(
  `^=${functionVal}${anyWrappedVal}${functionValEnding}(?:${opPlusVal})*$`,
)

// Compiled regex looks like
// ^=(?:(?:MAX|MIN|AVERAGE|OR|AND)?[(]*(?:(?:(?:MAX|MIN|AVERAGE|OR|AND)\\s*\\(\\s*(?:{[^{}]+:[^{}]+})\\s*\\))|(?:{[^{}]+})|[0-9.]+|[^\\s=]+)[)\\s]*)(?:(?:(?:>=|<=|[+*\\/><\\-=^,])\\s*(?:[(\\s]*(?:(?:(?:MAX|MIN|AVERAGE|OR|AND)\\s*\\(\\s*(?:{[^{}]+:[^{}]+})\\s*\\))|(?:{[^{}]+})|[0-9.]+|[^\\s=]+)[)\\s]*)))*$
// console.log(validForm.toString())
